import React, { useState, useEffect } from "react";
import { adminGetContactById, adminDeleteContact } from "../api/admin";
import { toast } from "react-toastify";
import { FaUser, FaEnvelope, FaCalendarAlt, FaTrash, FaCommentAlt } from "react-icons/fa";
import "./UserDetailsModal.css"; // Reuse existing details styling

const ContactDetailsView = ({ contactId, onDeleted }) => {
    const [contactData, setContactData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (contactId) {
            fetchContactDetails();
        }
    }, [contactId]);

    const fetchContactDetails = async () => {
        try {
            setLoading(true);
            const response = await adminGetContactById(contactId);
            if (response.data) {
                setContactData(response.data);
            } else {
                toast.error("Failed to load contact details");
            }
        } catch (error) {
            console.error("Error fetching contact details:", error);
            toast.error("Error loading contact details");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container" style={{ minHeight: '400px' }}>
                <div className="spinner"></div>
                <p>Retrieving contact details...</p>
            </div>
        );
    }

    if (!contactData) {
        return <div className="error-container">Contact data not available.</div>;
    }

    return (
        <div className="user-details-full-view">
            <div className="details-grid">
                {/* Left Column: Contact Header Card */}
                <div className="details-left-col">
                    <div className="profile-highlight-card">
                        <div className="profile-avatar">
                            {contactData.name?.[0]?.toUpperCase() || "C"}
                        </div>
                        <h3 className="profile-name">{contactData.name || "N/A"}</h3>
                        <div className="profile-status-badge verified" style={{ background: '#e1f0ff' }}>
                             Contact Submission
                        </div>
                        
                        <div className="wallet-card-inline" style={{ background: '#f8f9fa', border: '1px solid #ebedef' }}>
                            <div className="wallet-label" style={{ color: '#7e8299' }}>
                                <FaCalendarAlt /> Submitted On
                            </div>
                            <div className="wallet-amount" style={{ fontSize: '1.2rem', color: '#181c32' }}>
                                {new Date(contactData.createdAt).toLocaleDateString(undefined, {
                                    day: 'numeric', month: 'long', year: 'numeric'
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="contact-info-block">
                        <h4 className="block-title">Contact Information</h4>
                        <div className="info-item">
                            <span className="info-key"><FaUser /> Full Name</span>
                            <span className="info-val">{contactData.name || "N/A"}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-key"><FaEnvelope /> Email Address</span>
                            <span className="info-val">{contactData.email || "N/A"}</span>
                        </div>
                    </div>
                </div>

                {/* Right Column: Message Content */}
                <div className="details-right-col">
                    <div className="orders-history-block">
                        <div className="block-header">
                            <h4 className="block-title"><FaCommentAlt /> Message Content</h4>
                        </div>
                        
                        <div className="contact-message-body" style={{ 
                            padding: '30px', 
                            background: '#f8f9fa', 
                            borderRadius: '12px', 
                            lineHeight: '1.8', 
                            color: '#3f4254',
                            fontSize: '1.1rem',
                            minHeight: '200px',
                            whiteSpace: 'pre-wrap'
                        }}>
                            {contactData.message || "No message content."}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactDetailsView;
